import { useRef, type ReactElement } from 'react';
import { Excel, Icons, useTranslation } from '@common';
import * as Base from '@base';
import styles from '../style.module.less';
import { ImporterService } from '../service';
import type { UploaderProps } from '../types';

/**
 * 确认导入规则，上传导入文件
 */
export function Uploader(props: UploaderProps): ReactElement | null {
  const [t] = useTranslation();
  const { current: service } = useRef(new ImporterService());

  if (props.step !== 1) {
    return null;
  }

  // TODO: excel 相关异常处理
  const handleLoad = async (file: Blob | File): Promise<void> => {
    const [worksheet] = await new Excel().read(file);
    if (worksheet == null) {
      return;
    }
    const data = await service.parseValue(file, props.definitions);
    props.onNext(data);
  };

  return (
    <div className={styles.stepContent}>
      <div className={styles.uploaderWrap}>
        <Base.Upload.Dragger
          maxCount={1}
          accept='.xlsx'
          customRequest={() => {}}
          showUploadList={false}
          onChange={async info => await handleLoad(info.file.originFileObj!)}
          className={styles.uploader}
        >
          <p className={styles.uploaderIcon}>
            <Icons name='InboxOutlined' />
          </p>
          <p className='ant-upload-text'>{t('点击或拖拽文件到当前区域上传')}</p>
        </Base.Upload.Dragger>
      </div>
    </div>
  );
}
